import axios from 'axios';

const loadAbort = () => {
  return new AbortController();
};

export interface ProcessBatchPayload {
  property_id: string;
  image_urls: string[];
  features?: {
    property_summary?: boolean;
    image_processing?: boolean;
  };
}

export const processSearchSmartBatchEndpoint = (
  payload: ProcessBatchPayload,
  token: string = '',
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/rs/v1/admin/search-smart/process`,
        data: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        timeout: 300000,
      }),
    controller,
  };
};

export const getSearchSmartBatchStatusEndpoint = (
  jobId: string,
  token: string = '',
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/rs/v1/admin/search-smart/status/${jobId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        timeout: 15000,
      }),
    controller,
  };
};
